<script setup lang="ts">
import { ArrowRight, Trophy } from 'lucide-vue-next'
</script>

<template>
  <!-- Same card as WidgetTelegram / WidgetInstagram, leading to the quiz list. -->
  <NuxtLinkLocale
    to="/quiz"
    class="group relative block overflow-hidden rounded-lg bg-gradient-to-br from-[#F59E0B] to-[#EA580C] p-4 text-white transition-all duration-500 ease-out hover:from-[#FBBF24] hover:to-[#F97316]"
  >
    <Trophy
      class="absolute -bottom-4 -right-4 size-28 rotate-12 text-white/20 transition-transform duration-500 group-hover:rotate-0"
      aria-hidden="true"
    />
    <div class="relative z-10">
      <NuxtImg
        src="/images-backup/logos/logo-white.png"
        alt="Logo"
        class="mb-3"
        width="86"
        height="32"
      />

      <h3 class="mb-4 max-w-52 text-base font-bold leading-tight sm:text-xl">
        {{ $t('widget.quiz_promo.title') }}
      </h3>

      <span class="inline-flex items-center gap-1.5 text-sm font-bold">
        {{ $t('widget.quiz_promo.action') }}
        <ArrowRight class="size-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
      </span>
    </div>
  </NuxtLinkLocale>
</template>
